import React from 'react';
import './ChartShimmer.scss';

export type ChartShimmerProps = {
  bars?: number;
  height?: number;
};

const ChartShimmer: React.FC<ChartShimmerProps> = ({ 
  bars = 7,
  height = 280
}) => {
  // Generate varying heights for bars to look more realistic
  const barHeights = ['60%', '80%', '45%', '95%', '70%', '55%', '85%'];
  
  return (
    <div className="chart-shimmer">
      <div className="chart-shimmer__title shimmer-line"></div>
      <div className="chart-shimmer__subtitle shimmer-line"></div>
      
      <div className="chart-shimmer__content" style={{ height: `${height}px` }}>
        {Array.from({ length: bars }).map((_, index) => (
          <div key={`bar-${index}`} className="chart-shimmer__bar">
            <div 
              className="shimmer-line" 
              style={{ height: barHeights[index % barHeights.length] }}
            ></div>
            <div className="shimmer-line chart-shimmer__label"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChartShimmer;
